import { useQuery } from '@tanstack/react-query';
import { getVersionState } from './versionApi';
export const versionKeys = {
  all: ['admin', 'map-versions'] as const,
  state: (version: string) => ['admin', 'map-versions', version] as const,
  deletion: (id: string | undefined) => ['admin', 'map-deletions', id] as const,
};
export function useVersionState(version: string) {
  return useQuery({ queryKey: versionKeys.state(version), queryFn: ({ signal }) => getVersionState(version, signal), retry: false, refetchOnWindowFocus: false, staleTime: 1000 });
}
